import QueryRule from './query-rule';

const rulesMap = (/** @type {any} */ r) => {
	let rule;
	if (r.field) {
		rule = new QueryRule(r);
	}
	else if (r.rules) {
		// eslint-disable-next-line no-use-before-define
		rule = new QueryWhere(r);
	}
	return rule;
};

export default class QueryWhere {
	/**
	 * @param {any} where
	 */
	constructor(where = null) {
		/** @type {'AND' | 'OR' } */
		this.condition = where?.condition ?? 'AND';

		/** @type {(QueryRule | QueryWhere)[]} */
		this.rules = where?.rules?.map((/** @type {any} */ r) => rulesMap(r)) ?? [];
	}

	removeRules() {
		this.rules.length = 0;
	}
}
